import { useState } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import AnimatedOutlet from '@/components/RouteTransition/AnimatedOutlet';
import Navbar from '@/components/Navbar/Navbar';
import { Sidebar } from '@/components/Sidebar/Sidebar';
import './_authenticated.css';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (context.auth.loading) {
      return;
    }

    if (!context.auth.user) {
      return redirect({
        to: '/login',
        search: {
          redirect: location.pathname,
        },
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { auth } = Route.useRouteContext();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (auth.loading) {
    return (
      <div className="loading-container">
        <div className="spinner" />
        <p className="loading-text">Carregando...</p>
      </div>
    );
  }

  return (
    <div className="authenticated-layout">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="authenticated-layout__shell">
        <Navbar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen((open) => !open)}
        />
        <div className="authenticated-layout__content">
          <AnimatedOutlet />
        </div>
      </div>
    </div>
  );
}
